// extracted by mini-css-extract-plugin
export var noItems = "OrderSelectItem-module--noItems--81jz9";